/**
 * Message
 * The Message API
 *
 * The version of the OpenAPI document: master-8247d258-900790
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@nestjs/common';
import { HttpService } from '@nestjs/axios';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { Check200Response } from '../model/check200Response';
import { Check503Response } from '../model/check503Response';
import { Configuration } from '../configuration';
import { COLLECTION_FORMATS } from '../variables';


@Injectable()
export class HealthApi {

    protected basePath = 'http://.';
    public configuration = new Configuration();

    constructor(protected httpClient: HttpService, @Optional() configuration: Configuration) {
        this.configuration = configuration || this.configuration;
        this.basePath = configuration?.basePath || this.basePath;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        return consumes.includes(form);
    }

    /**
     * 
     * 
     */
    public alive(): Observable<AxiosResponse<Check200Response>>;
    public alive(): Observable<any> {

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<Check200Response>(`${this.basePath}/private/health/alive`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     */
    public check(): Observable<AxiosResponse<Check200Response>>;
    public check(): Observable<any> {

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<Check200Response>(`${this.basePath}/private/health`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
